import { render, staticRenderFns } from "./_profile.vue?vue&type=template&id=3dd1af54&"
import script from "./_profile.vue?vue&type=script&lang=js&"
export * from "./_profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports